import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';

import {
  GenericLoginPrompt,
  type LoginPromptProps,
} from '../../GenericLoginPrompt/GenericLoginPrompt';

import translations from './.vocab';

import { loginBannerProfileViewBackgroundImgStyle } from './SignedOutLoginPrompt.css';

export const SignedOutProfileLoginPrompt = ({
  authUrls,
  trackingCallbacks,
}: {
  authUrls: { loginUrl: string; googleLoginUrl: string; registerUrl: string };
  trackingCallbacks: LoginPromptProps['trackingCallbacks'];
}) => {
  const { t } = useTranslations(translations);

  return (
    <>
      <Box className={loginBannerProfileViewBackgroundImgStyle} />
      <GenericLoginPrompt
        loginUrl={authUrls.loginUrl}
        googleLoginUrl={authUrls.googleLoginUrl}
        registerUrl={authUrls.registerUrl}
        headingText={t('SIGN_IN_TO_SEE_MORE')}
        loginBulletPoints={[
          t('UNLOCK_PROFILE_DETAILS_SKILLS_AND_FILTERS'),
          t('CHECK_VERIFIED_CREDENTIALS'),
          t('BROWSE_AND_COMPARE_PROFILES'),
        ]}
        trackingCallbacks={trackingCallbacks}
        alignContent="center"
      />
    </>
  );
};
